import { createSlice } from '@reduxjs/toolkit';

export interface IMenuItem {
  tenChucNang: string;
  url: string;
  icon?: string | null;
  hienThi: boolean;
  children?: Array<IMenuItem>;
}

const homePage: IMenuItem = {
    tenChucNang: ' Trang chủ',
    url: '/',
    icon: 'fas fa-tachometer-alt nav-icon" />',
    hienThi: true,
    children: []
}

export interface ListMenu {
    isAvailableMenu: boolean;
  items: IMenuItem[];
}

const initialState: ListMenu = {
    isAvailableMenu: !!localStorage.getItem('menu'),
    items: [
        {
            tenChucNang: ' Trang chủ',
            url: '/',
            icon: 'fas fa-tachometer-alt nav-icon" />',
            hienThi: true,
            children: []
        }
    ]
};

export const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        loadMenu: (state, { payload }) => {
            payload = [homePage, ...payload];
            localStorage.setItem('menu', JSON.stringify(payload));
            state.items = payload;
            state.isAvailableMenu = true;
        },
        removeMenu: (state) => {
            localStorage.removeItem('menu');
            state.items = [];
            state.isAvailableMenu = false;
        },

    }
});

export const { removeMenu, loadMenu } = menuSlice.actions;

export default menuSlice.reducer;
